<template>
    <div class="date-range-input">
        <v-menu
            ref="menu"
            :close-on-content-click="dateRange.length > 1"
            v-model="menu"
            transition="scale-transition"
            offset-y
            min-width="200px">
            <template v-slot:activator="{ on }">
                <v-text-field
                    slot="activator"
                    v-model="displayDateRange"
                    prepend-inner-icon="event"
                    readonly
                    v-on="on"
                    solo
                    dense
                    :clearable="clearable"
                    :disabled="disabled"
                    @click:append="menu = true"
                    :height="height"
                    background-color="#ffffff">
                </v-text-field>
            </template>
            <v-date-picker
                range
                v-model="dateRange">
            </v-date-picker>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'DatePickerRange',

    props: {
        value: {
            type: Array,
            default: () => ([]),
            validator (v) {
                const result = v.length < 3
                return v.reduce((prevResult, date) => {
                    return prevResult && Date.parse(date)
                }, result)
            }
        },
        clearable: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: '40px'
        }
    },

    data () {
        return {
            menu: false,
            maxDate: this.$dateUtil.getCurrentDate(),
            displayDateRange: null,
            dateRange: []
        }
    },
    methods: {
        dateRangeText () {
            let text = null
            if (this.dateRange.length === 1) {
                text = this.$dateUtil.formatDateBE(this.dateRange[0], 1)
            } else if (this.dateRange.length === 2) {
                const date1 = this.$dateUtil.formatDateBE(this.dateRange[0], 1)
                const date2 = this.$dateUtil.formatDateBE(this.dateRange[1], 1)
                text = `${date1} - ${date2}`
            }

            this.displayDateRange = text
            this.$emit('input', this.dateRange)
        }
    },

    mounted () {
        this.dateRange = this.value
    },

    watch: {
        dateRange: {
            handler: function (newVal, oldVal) {
                if (newVal.length === 2 && newVal[0] > newVal[1]) {
                    this.dateRange = [newVal[1], newVal[0]]
                }
                this.dateRangeText()
            }
        },
        displayDateRange () {
            if (this.displayDateRange === null) {
                this.dateRange = []
            }
        }
    }

}
</script>

<style lang="scss" scoped>
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
    }

    ::v-deep .v-input__prepend-inner {
        margin: auto !important;
    }
</style>
